var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"ma-2",attrs:{"width":"100%"}},[_c('div',{staticStyle:{"width":"95%","min-height":"500px","margin":"0 auto"},attrs:{"id":"heatmap-metap-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }